module.exports = __webpack_public_path__ + "static/Amey-Banarse-6fddac03f1c47b8dcaf74b7b7098f3c8.jpg";